import { render } from "./gameStarted.vue?vue&type=template&id=19bd2bc9"
import script from "./gameStarted.vue?vue&type=script&lang=js"
export * from "./gameStarted.vue?vue&type=script&lang=js"

import "./gameStarted.vue?vue&type=style&index=0&id=19bd2bc9&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__